import { Component,AfterViewInit, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../../shared/services/shared.service';
import { environment } from '../../../../environments/environment';
import videojs, { VideoJsPlayer } from 'video.js';

declare var videojs: any;
declare var $: any;


@Component({
  selector: 'app-nyc-video-play',
  templateUrl: './nyc-video-play.component.html',
  styleUrls: ['./nyc-video-play.component.css']
})
export class NycVideoPlayComponent implements AfterViewInit  {
  @ViewChild('videoPlayer', { static: false }) videoElement!: ElementRef;
  player: any;
  private videoUrl: string = '';

  ngAfterViewInit() {
    $('#nma-about-modal').on('hidden.bs.modal', () => {
      this.pauseVideo();
    });
  }

  open(src: string) {
    this.videoUrl = src;
    $('#nma-about-modal').modal('show');

    setTimeout(() => {
      if (!this.player) {
        this.player = videojs(this.videoElement.nativeElement, {
          autoplay: true,
          controls: true,
          sources: [
            {
              src: this.videoUrl,
              type: 'application/x-mpegURL',
            },
          ],
        });
      } else {
        this.player.src({ src: this.videoUrl, type: 'application/x-mpegURL' });
        this.player.play();
      }
    }, 300);
  }

  close() {
    this.pauseVideo();
    $('#nma-about-modal').modal('hide');
  }

  private pauseVideo() {
    if (this.player) {
      this.player.pause();
    } else if (this.videoElement?.nativeElement) {
      this.videoElement.nativeElement.pause();
    }
  }

}



